import { FCWithChildren } from 'react';
import { getEnvSettings } from '../app/hostBasedSettings';
import { nameof } from '../utils/stringUtils';
import AuthServiceProvider from '../app/authentication/AuthServiceProvider';
import DialogProvider from './DialogProvider';
import PageAccessProvider from './PageAccessProvider';
import PageSizeProvider from './PageSizeProvider';
import SettingsProvider from './SettingsProvider';
import SignalrDataProvider from './SignalrDataProvider';
import TemporaryDataCacheProvider from './TemporaryDataCacheProvider';
import ThemeProvider from './ThemeProvider';

const settings = getEnvSettings();

const Providers: FCWithChildren = ({ children }) => (
  <SettingsProvider>
    <AuthServiceProvider opts={settings}>
      <PageAccessProvider>
        <SignalrDataProvider>
          <ThemeProvider>
            <DialogProvider>
              <PageSizeProvider>
                <TemporaryDataCacheProvider>
                  {children}
                </TemporaryDataCacheProvider>
              </PageSizeProvider>
            </DialogProvider>
          </ThemeProvider>
        </SignalrDataProvider>
      </PageAccessProvider>
    </AuthServiceProvider>
  </SettingsProvider>
);

Providers.displayName = nameof({ Providers });
export default Providers;